module.exports = __webpack_public_path__ + "static/media/dealer.d71f6181.jpg";